export enum VehiclesEndpoints {
    GetTracking = "insureds/:userIdentity/insurances/vehicle/policies/:policyId/kms-tracking",
    GetVehicle = "insureds/:userIdentity/insurances/all/policies/:policyId/vehicles",
}
